(function () {
  const CFG = window.NOT_SORRY_CONFIG;
  const TIER = CFG.PRICES[CFG.TIER] || CFG.PRICES.preorder;
  const CUR = CFG.CURRENCY || "AED";

  const money = n => CUR + " " + n;

  // What each bundle would cost bought separately — used for the strikethrough.
  // Derived rather than hardcoded so it can never drift from the price list.
  const fullPrice = {
    duo: TIER.tee + TIER.shorts + (TIER.bundleFreeCap ? TIER.cap : 0),
    trio: TIER.tee * 2 + TIER.shorts + (TIER.bundleFreeCap ? TIER.cap : 0),
  };

  // Shop grid: studio shot by default, shoot photo on hover, whole tile links
  // through to the product page.
  function renderShopGrid() {
    const grid = document.getElementById("merch-grid");
    const catalog = window.NOT_SORRY_PRODUCTS;
    if (!grid || !catalog) return;

    // bundles live in the same catalogue (they need product pages too) but
    // have their own section, so keep them out of the shop grid
    grid.innerHTML = Object.keys(catalog).filter(id => !catalog[id].isBundle).map(id => {
      const p = catalog[id];
      const hasHover = p.worn && p.worn !== p.studio;
      return `
        <a class="merch-tile" href="${CFG.ROUTES.product({ id: id, handle: (p.shopify||{}).handle })}">
          <img class="tile-studio" src="${p.studio}" alt="${p.name}" />
          ${hasHover ? `<img class="tile-worn" src="${p.worn}" alt="" aria-hidden="true" />` : ""}
          <div class="merch-tile-fade"></div>
          <div class="merch-tile-label">
            <div class="merch-tile-name">${p.name}</div>
            <div class="merch-tile-meta">${p.meta}</div>
            <div class="merch-tile-price" data-price="${p.price}"></div>
            <span class="product-cta cta">View →</span>
          </div>
        </a>`;
    }).join("");
  }

  function renderPrices() {
    document.querySelectorAll("[data-price]").forEach(el => {
      const key = el.getAttribute("data-price");
      if (TIER[key] != null) el.textContent = money(TIER[key]);
    });

    // strikethrough "was" prices, only when the bundle actually saves money
    document.querySelectorAll("[data-was]").forEach(el => {
      const key = el.getAttribute("data-was");
      const was = fullPrice[key];
      if (was && was > TIER[key]) {
        el.textContent = money(was);
        el.removeAttribute("data-hidden");
      } else {
        el.setAttribute("data-hidden", "");
      }
    });

    // "+ FREE CAP" flash on the bundles, pre-order only
    document.querySelectorAll("[data-bundle-tag]").forEach(el => {
      const key = el.getAttribute("data-bundle-tag");
      const saving = fullPrice[key] ? fullPrice[key] - TIER[key] : 0;
      const bits = [];
      if (TIER.bundleFreeCap) bits.push("+ Free cap");
      if (saving > 0) bits.push("Save " + money(saving));
      if (bits.length) {
        el.textContent = bits.join("  ·  ");
        el.removeAttribute("data-hidden");
      } else {
        el.setAttribute("data-hidden", "");
      }
    });

    const eyebrow = document.getElementById("hero-eyebrow");
    if (eyebrow) eyebrow.textContent = "Drop 3.0 / " + TIER.label + " open";
  }

  // Every product and bundle now routes through its own page, where the buy
  // button resolves to a real Shopify variant. The hero just points inward.
  function renderHeroCtas() {
    const hero = document.getElementById("hero-cta-slot");
    if (!hero) return;
    hero.innerHTML =
      '<a class="cta" href="#shop">Shop the drop \u2192</a>' +
      '<a class="cta cta-ghost" href="#bundles">See bundles</a>';
  }

  // Bundle cards are authored in HTML, so their hrefs are stamped here rather
  // than hardcoded to a local filename.
  function applyProductLinks() {
    const catalog = window.NOT_SORRY_PRODUCTS || {};
    document.querySelectorAll("[data-goto]").forEach(el => {
      const pid = el.getAttribute("data-goto");
      if (!catalog[pid]) return;
      el.setAttribute("href", CFG.ROUTES.product({ id: pid, handle: (catalog[pid].shopify || {}).handle }));
    });
  }

  function applySocialLinks() {
    const social = CFG.SOCIAL || {};
    document.querySelectorAll("[data-social]").forEach(el => {
      const url = social[el.getAttribute("data-social")];
      if (url) { el.setAttribute("href", url); el.removeAttribute("data-hidden"); }
      else { el.setAttribute("data-hidden", ""); }
    });
  }

  // Reels are muted+autoplay+loop, but Safari/iOS and backgrounded tabs still
  // pause them. Nudge on load, on scroll-into-view, and when the tab returns.
  function keepReelsPlaying() {
    const reels = document.querySelectorAll(".reel video");
    if (!reels.length) return;
    const play = v => { const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    reels.forEach(play);
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        entries => entries.forEach(e => { if (e.isIntersecting) play(e.target); }),
        { threshold: 0.1 }
      );
      reels.forEach(v => io.observe(v));
    }
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) reels.forEach(play);
    });
  }

  function init() {
    renderShopGrid();   // must run before prices, it creates the price nodes
    renderPrices();
    renderHeroCtas();
    applyProductLinks();
    applySocialLinks();
    keepReelsPlaying();
    const yearEl = document.getElementById("year");
    if (yearEl) yearEl.textContent = new Date().getFullYear();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
